import React from "react";
import { graphql } from "gatsby";
import ReactMarkdown from "react-markdown";
import Layout from "../components/App/Layout";
import PageBanner from "../components/Common/PageBanner";
import Sidebar from "../components/Trend/Sidebar";
import SEO from "../components/App/SEO";
import ReservationBlock from "../components/Common/ReservationBlock";
import { removeMarkdownFormatting } from "../libs/utils";

const query = graphql`
  query GetSingleTrend($slug: String) {
    trend: strapiTrend(slug: { eq: $slug }) {
      title
      content
      image {
        childImageSharp {
          fixed {
            src
          }
        }
      }
    }
  }
`;

const ComponentName = ({ data }) => {
  const { title, content, image } = data.trend;
  const plainText = removeMarkdownFormatting(content);
  const desc = plainText.substring(0, 140);

  return (
    <Layout>
      <SEO title={`${title}-大任软件客户案例`} description={desc} />
      <PageBanner
        pageTitle={title}
        breadcrumbs={[
          { text: "首页", url: "/" },
          { text: "客户案例", url: "/trends/page_1" },
        ]}
        activePageText="详情"
        pageImage={image && image.childImageSharp && image.childImageSharp.fixed.src}
      />
      <section className="blog-details-area ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className="blog-details-desc">
                <ReactMarkdown allowDangerousHtml className="text-left prades-indent">
                  {content}
                </ReactMarkdown>
              </div>
            </div>
            <div className="col-lg-4 col-md-12">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>
      <ReservationBlock light omits={["services", "scale"]} />
    </Layout>
  );
};

export { ComponentName as default, query };
